var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnerMenuIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 152 152",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    id: "fi_3097071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black_And_White",
    "data-name": "Black And White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_16.P",
    "data-name": "16.P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.9 54.3c2 2.23 3 5.22 3 9q0 5.11-2.94 7.91c-1.96 1.79-4.78 2.79-8.52 2.79h-12.64v-23.11h12.86a10.68 10.68 0 0 1 8.24 3.41z",
    fill: "rgba(154, 154, 181, 1.00)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 0h-128a12 12 0 0 0 -12 12v128a12 12 0 0 0 12 12h128a12 12 0 0 0 12-12v-128a12 12 0 0 0 -12-12zm-40.9 81.85q-8.37 7-23 7h-12.3v27.15h-19.28v-80h31.92a37.24 37.24 0 0 1 16.24 3.38 25.5 25.5 0 0 1 10.93 9.62 26.3 26.3 0 0 1 3.87 14.15q0 11.71-8.38 18.7z",
    fill: "rgba(154, 154, 181, 1.00)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerMenuIcon);
export default __webpack_public_path__ + "static/media/PartnerMenuIcon.441407591c6f7324690399f16853b637.svg";
export { ForwardRef as ReactComponent };